<template>
    <div id="box">
      <img src="../assets/loading.gif" style="width: 500px;height: 390px;" alt="">
      <p class="tipsText">正在进入直播间请稍等...</p>
    </div>
  </template>
  <script>
  import { getUserInfoAjax, getUserSig, getStuUserInfo,refreshToken } from "@/utils/getData.js";
  import { setCookie, getCookie } from '@/utils/cookie.js'
  export default {
    components: {},
    data() {
      return {};
    },
    computed: {},
    watch: {},
    methods: {
      // 获取地址栏信息
      getUrlSearch(name) {
        if (!name) return null;
        var after = window.location.search;
        after = after.substr(1) || window.location.hash.split("?")[1];
        if (!after) return null;
        if (after.indexOf(name) === -1) return null;
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = decodeURI(after).match(reg);
        if (!r) return null;
        return r[2];
      },
    },
    created() {
      let _this = this;
      setCookie('refreshToken', this.getUrlSearch("t"))
      setCookie('tenantId', this.getUrlSearch("tenantId"))
      //this.$store.commit('roleTypeMutations',this.getUrlSearch("type"))
      setCookie('groupId', this.getUrlSearch("groupId"))
      //刷新令牌
      refreshToken(this.getUrlSearch("t")).then(res => {
        if(res.code == 0){

          setCookie('accessToken',res.data.accessToken)
          setCookie('refreshToken',res.data.refreshToken)

          getUserInfoAjax({groupId:this.getUrlSearch("groupId")}).then(req => {
            console.log("111")
            const jsonString = JSON.stringify(req.data);
            
            console.log(jsonString)
            setCookie('userInfo',btoa(unescape(encodeURIComponent(jsonString))))
            setCookie('roomId',req.data.roomId)
            setCookie('userSig',req.data.meetingSig)

            _this.$router.push({ path: "/room" });
          })

        }else{
          _this.error("登录过期")
          console.log("11111111")
        }


      })


    },
  };
  </script>
  <style lang='scss' scoped>
  //@import ''; 引入公共css类
  #box {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .tipsText {
      font-size: 32px;
      color: #dea1e5;
    }
  }
  </style>